/**
 * Case Settings API service
 *
 * Provides functions for managing case settings and organisation case defaults.
 */

import { apiClient } from './api'
import type {
  CaseSettings,
  EffectiveCaseSettings,
  OrgCaseDefaults,
  UpdateCaseSettingsRequest,
  UpdateOrgCaseDefaultsRequest,
} from '../types/case-container'

// =============================================================================
// CASE SETTINGS
// =============================================================================

/**
 * Get effective settings for a case (merged with org defaults)
 */
export async function getCaseSettings(caseId: string): Promise<EffectiveCaseSettings> {
  return apiClient.get<EffectiveCaseSettings>(`/cases/${caseId}/settings`)
}

/**
 * Update settings for a case
 */
export async function updateCaseSettings(
  caseId: string,
  settings: UpdateCaseSettingsRequest
): Promise<CaseSettings> {
  return apiClient.put<CaseSettings>(`/cases/${caseId}/settings`, settings)
}

// =============================================================================
// ORGANISATION CASE DEFAULTS
// =============================================================================

/**
 * Get case defaults for the user's organisation
 */
export async function getOrgCaseDefaults(): Promise<OrgCaseDefaults> {
  return apiClient.get<OrgCaseDefaults>('/org/case-defaults')
}

/**
 * Update case defaults for the user's organisation
 */
export async function updateOrgCaseDefaults(
  defaults: UpdateOrgCaseDefaultsRequest
): Promise<OrgCaseDefaults> {
  return apiClient.put<OrgCaseDefaults>('/org/case-defaults', defaults)
}
